import { ConnectKitButton } from 'connectkit';
import { Button } from '@mui/material';
export const DashboardConnectButton = () => {
  return (
    <ConnectKitButton.Custom>
      {({ isConnected, show, address }) => {
        return (
          <Button onClick={show} sx={{ color: 'buttonBlue', fontSize: '1rem', padding: '0' }}>
            {isConnected ? address : 'Connect'}
          </Button>
        );
      }}
    </ConnectKitButton.Custom>
  );
};
